import AuthorContainer from '../../author/authorContainer';
import ArticleInfo from '../../articleInfo/articleInfo';
import CitedByContainer from '../../citedBy/citedByContainer';
import CitedByPreviewContainer from '../../articlePreview/containers/citedByPreviewContainer';
import Connections from '../../connections/connections';
import ConnectionsPreviewContainer from '../../articlePreview/containers/connectionsPreviewContainer';
import Figure from '../../figure/figure';
import FiguresContainer from '../../figures/figuresContainer';
import OutlineContainer from '../../outline/outlineContainer';
import RecommendationsPreviewContainer from '../../articlePreview/containers/recommendationsPreviewContainer';
import RecentPublicationsPreviewContainer from '../../articlePreview/containers/recentPublicationsPreviewContainer';
import ReferencesContainer from '../../references/referencesContainer';
import { panelType } from '../../../../shared/constants';

export default {
  [panelType.author]: {
    component: AuthorContainer,
    analytics: {
      openPanelFeature: 'inline-author',
      closePanelFeature: 'author-closed',
    },
    supportsViewerHighlights: true,
  },
  [panelType.articleInfo]: {
    component: ArticleInfo,
    analytics: {
      openPanelFeature: 'articleInfo-opened',
      closePanelFeature: 'articleInfo-closed',
    },
  },
  [panelType.citedBy]: {
    component: CitedByContainer,
    analytics: {
      openPanelFeature: 'citingArticles-opened',
      closePanelFeature: 'citingArticles-closed',
    },
  },
  [panelType.citedByArticlePreview]: {
    component: CitedByPreviewContainer,
    analytics: {
      openPanelFeature: 'citingArticlesPreview-opened',
      closePanelFeature: 'citingArticlesPreview-closed',
    },
  },
  [panelType.connections]: {
    component: Connections,
    analytics: {
      openPanelFeature: 'connections-opened',
      closePanelFeature: 'connections-closed',
    },
  },
  [panelType.connectionsArticlePreview]: {
    component: ConnectionsPreviewContainer,
    analytics: {
      openPanelFeature: 'connectionsPreview-opened',
      closePanelFeature: 'connectionsPreview-closed',
    },
  },
  [panelType.figure]: {
    component: Figure,
    analytics: {
      openPanelFeature: 'figure-opened',
      closePanelFeature: 'figure-closed',
    },
    supportsViewerHighlights: true,
  },
  [panelType.figures]: {
    component: FiguresContainer,
    analytics: {
      openPanelFeature: 'figures-opened',
      closePanelFeature: 'figures-closed',
    },
    display: 'stacked',
  },
  [panelType.outline]: {
    component: OutlineContainer,
    analytics: {
      openPanelFeature: 'outline-opened',
      closePanelFeature: 'outline-closed',
    },
  },
  [panelType.recentPublicationsArticlePreview]: {
    component: RecentPublicationsPreviewContainer,
    analytics: {
      openPanelFeature: 'recentPublicationsPreview-opened',
      closePanelFeature: 'recentPublicationsPreview-closed',
    },
  },
  [panelType.recommendationsArticlePreview]: {
    component: RecommendationsPreviewContainer,
    analytics: {
      openPanelFeature: 'recommendationsPreview-opened',
      closePanelFeature: 'recommendationsPreview-closed',
    },
  },
  [panelType.reference]: {
    component: ReferencesContainer,
    analytics: {
      openPanelFeature: 'inline-reference',
      closePanelFeature: 'reference-closed',
    },
    supportsViewerHighlights: true,
  },
};
